import { i18n } from '../../global/constants.js';

export const BEM_BLOCK_NAME = 'person_record';

export const PERSON_RECORD_TITLE = i18n('Person Record ID:');
export const PERSON_RECORD_TITLE_V2 = i18n('Person Record');
